import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrash, faPlus } from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import classnames from "classnames";
import Loader from "../../Loader/Loader";
import ConfirmModal from "./ConfirmModal";
import EditModal from "./EditModal";
import styles from "./DataBox.scss";

const types = [
  "Libraries",
  "Schools",
  "Healthcare",
  "Worship",
  "GroceryStores",
  "Marinas",
  "DogParks",
  "Restaurants",
  "Sports",
  "Transportation",
  "Entertainment",
  "Childcare",
  "ParkAndRides",
  "Culture"
];

export default class MapData extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: undefined,
      datum: undefined,
      data_schema: undefined,
      showConfirmModal: false,
      showEditModal: false,
      type: "Libraries"
    };
  }

  updateTable = () => {
    axios.defaults.headers.common["Authorization"] = localStorage.getItem(
      "jwt"
    );
    console.log("Updating MapData...");
    axios
      .get(`/api/data/${this.state.type}`,
  		{
  			headers: { Authorization: "Bearer K1Ng57ONHUB4PIK3Y" }
  		})
      .then(res => {
        this.setState({
          data: res.data
        });
      })
      .catch(e => console.log(e));
  };

  getNewDataSchema = () => {
    console.log(...this.state.data[0]);
    var data = { ...this.state.data[0] };
    var data_schema = {};

    Object.entries(data).map(ent => {
      if (ent[0] === "_id") {
        return null;
      } else if (typeof ent[1] === "string") {
        data_schema[ent[0]] = "";
        return null;
      } else if (typeof ent[1] === "boolean") {
        data_schema[ent[0]] = false;
        return null;
      } else if (typeof ent[1] === "number") {
        data_schema[ent[0]] = 0;
        return null;
      } else {
        data_schema[ent[0]] = "";
        return null;
      }
    });

    this.showEditModal(data_schema);
  };

  showConfirmModal = datum => {
    this.setState({ showConfirmModal: true, datum: datum });
  };

  hideConfirmModal = () => {
    this.setState({ showConfirmModal: false });
  };

  showEditModal = datum => {
    this.setState({ showEditModal: true, datum: datum });
  };

  hideEditModal = () => {
    this.setState({ showEditModal: false });
  };

  deleteData(datum, type) {
    axios.defaults.headers.common["Authorization"] = localStorage.getItem(
      "jwt"
    );
    axios
      .post("/api/admin/removemapdata", { data: datum, type: type })
      .then(res => {
        this.updateTable();
      })
      .catch(e => console.log(e));
  }

  updateOrAdd(datum, type) {
    axios.defaults.headers.common["Authorization"] = localStorage.getItem(
      "jwt"
    );
    axios
      .post("/api/admin/updateoraddmapdata", { data: datum, type: type })
      .then(res => {
        this.updateTable();
      })
      .catch(e => console.log(e));
  }

  componentDidMount = () => {
    this.updateTable();
  };

  componentDidUpdate(prevProps, prevState) {
    if (this.state.type !== prevState.type) {
      this.updateTable();
    }
  }

  render() {
    if (this.state.data === undefined) {
      return (
        <div className={styles.dataBox}>
          <Loader />
        </div>
      );
    } else {
      return (
        <div className={styles.dataBox}>
          <ConfirmModal
            show={this.state.showConfirmModal}
            handleClose={this.hideConfirmModal}
            data={this.state.datum}
            deleteData={this.deleteData}
            updateTable={this.updateTable}
            type={this.state.type}
          />
          <EditModal
            show={this.state.showEditModal}
            handleClose={this.hideEditModal}
            data={this.state.datum}
            updateOrAdd={this.updateOrAdd}
            updateTable={this.updateTable}
            type={this.state.type}
          />

          <div className={classnames("btn-group", styles.tabs)} role="group">
            {types.map(t => {
              return (
                <button
                  type="button"
                  className={classnames("btn btn-secondary", {
                    [styles.tabSelected]: this.state.type === t
                  })}
                  onClick={() => this.setState({ type: t })}
                >
                  {this.name ? this.name : t}
                </button>
              );
            })}
          </div>

          <button
            className={classnames("btn btn-info", styles.modalButtons)}
            onClick={() => this.getNewDataSchema()}
          >
            <FontAwesomeIcon className={styles.cursor} icon={faPlus} />
          </button>
          <div
            className={classnames("table-responsive text-nowrap", styles.table)}
          >
            <table className="table table-striped w-auto">
              <thead>
                <tr>
                  <th scope="col">S/N</th>
                  {Object.entries(this.state.data[0])
                    .slice(1)
                    .map((d, i) => (
                      <th scope="col" key={i}>
                        {d[0]}
                      </th>
                    ))}
                  <th scope="col" className="textCenter">
                    Edit
                  </th>
                  <th scope="col" className="textCenter">
                    Delete
                  </th>
                </tr>
              </thead>
              <tbody>
                {this.state.data.map((row, i) => (
                  <tr key={row._id}>
                    <td>{i + 1}</td>
                    {Object.entries(this.state.data[0])
                      .slice(1)
                      .map(col => (
                        <td key={col[1]}>{this.state.data[i][col[0]]}</td>
                      ))}

                    <td className="textCenter">
                      <FontAwesomeIcon
                        className={styles.cursor}
                        onClick={() => this.showEditModal(row)}
                        style={{ color: "#323643" }}
                        icon={faEdit}
                      />
                    </td>
                    <td className="textCenter">
                      <FontAwesomeIcon
                        className={styles.cursor}
                        onClick={() => this.showConfirmModal(row)}
                        style={{ color: "#323643" }}
                        icon={faTrash}
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      );
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/Admin/MapData.js